module.exports = __webpack_public_path__ + "img/Slice 18@2x.6fcc6f77.png";